import {createSelector} from "@reduxjs/toolkit";
import rootSelector from "../rootSelector";

export const itemContainerItemSelector = createSelector(rootSelector, s => s.itemContainerFilterConfig);
